import { LIMPAR_FECHAMENTOS_CAIXA } from '../types'

export default function limparFechamentosCaixa () {
  return {
    type: LIMPAR_FECHAMENTOS_CAIXA,
    payload: []
  }
}
